import { Controller } from "@hotwired/stimulus"

// The resolutions a screen offers stand under the surface as badges (GER-40).
// A click fills width and height, nothing more: saving stays with the form, and
// the device takes the resolution over from there (GER-37).
export default class extends Controller {
  static targets = ["width", "height"]

  take({ params: { width, height } }) {
    this.widthTarget.value = width
    this.heightTarget.value = height
    this.widthTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.heightTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
